module.exports = __webpack_public_path__ + "static/media/left-arrow-icon-red.b7c8d3fe.svg";